import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enLocales from './en.json';
import agents from './en/agents.json';
import teams from './en/teams.json';
import enrichment from './en/enrichment.json';
import loan_officers from './en/loan_officers.json';
import company_trends from './en/company_trends.json';
import loan_transactions from './en/loan_transactions.json';
import companies from './en/companies.json';
import opportunities from './en/opportunities.json';

let lng = 'en';

if (typeof localStorage !== 'undefined') {
  lng = localStorage.getItem('i18nextLng') || 'en';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translations: { ...enLocales },
        agents,
        teams,
        loan_officers,
        company_trends,
        loan_transactions,
        enrichment,
        companies,
        opportunities,
      },
    },
    lng,
    fallbackLng: 'en',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
